/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconPlanet2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M18.746 12.474a6.75 6.75 0 0 1-10.609 5.813M6.08 15.994a6.75 6.75 0 1 1 11.84-6.488M19.235 8.786l-14.47 7.928" />
        <path d="M5.254 13.026l-1.931 1.057a3 3 0 0 0 2.884 5.262l14.47-7.928a3 3 0 0 0-2.884-5.262l-1.93 1.058M3 1.5v3M1.5 3h3M21 19.5v3M19.5 21h3" />
      </g>
    </svg>
  ),
);
